import React, { useEffect, useState } from "react";
import * as style from "./ApplicationList.module.scss";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { IconButton } from "cprime-foundational-components";
import Button from "../../Components/Common/CprimeButton";
import GridTable from "cvmgmt-cube-grid-table";
import { getEnv } from "../../Constants/env";
import { triggerToast } from "../../utils/toast";
import { applicationApprovalDenyRevoke } from "../../services/RequestAccess/RequestAccess";
import { StatusType } from "../../enums/RolesEnum";
import { useSelector } from "react-redux";
import { useIdToken } from "../../hooks/useAuthSession";

function ApplicationListMain() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { env } = useSelector((state: any) => state?.createApplication);
  const scssClass = style as any;

  const navigate = useNavigate();
  const idToken = useIdToken();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const [actionRowData, setActionRowData] = useState<any | null>(null);
  const [reasonForAction, setReasonForAction] = useState<any>("");
  const [actionPopup, setActionPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState<number>(0);

  const openActionPopup = () => setActionPopup((prev) => !prev);
  const [popupData, setPopupData] = useState<any>("");

  const handleCellAction = async (request: any) => {
    if (reasonForAction?.trim() === "") {
      triggerToast("Please provide a reason for the action.", "error");
      return;
    }

    try {
      setLoading(true);
      const response = await applicationApprovalDenyRevoke({
        appId: request?.id,
        action: popupData,
        comment: reasonForAction,
      });

      if (response?.status?.toLowerCase() === "success") {
        triggerToast(response?.message, response?.status?.toLowerCase());
        setRefresh((prev) => prev + 1);
        openActionPopup();
      } else if (response?.status?.toLowerCase() === "failure") {
        triggerToast(response?.message, "error");
      }
    } catch (error: any) {
      triggerToast(error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!actionPopup) {
      setPopupData("");
    }
  }, [actionPopup]);

  const handleApproveReason = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const value = event?.target?.value;
    setReasonForAction(value);
  };

  return (
    <>
      <div className={scssClass.page}>
        <div className={scssClass.container}>
          <div className={scssClass.header}>
            <div className={scssClass.title}>Applications</div>
            <Button
              variant="tertiary"
              size="medium"
              onClick={() => navigate("/onboard-application")}
            >
              Onboard Application
            </Button>
          </div>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              "& .MuiButtonBase-root": {
                color: "black !important",
                backgroundColor: "white",
              },
              "& .MuiTabs-indicator": {
                color: "black !important",
                backgroundColor: "black !important",
              },
              "& .MuiTabs-root": {
                marginBottom: "0px !important",
              },
            }}
          >
            <Tab
              label="Active"
              sx={{
                textTransform: "none",
                fontWeight: selectedTab === 0 ? "bold" : "",
              }}
            />
            <Tab
              label="Archived"
              sx={{
                textTransform: "none",
                fontWeight: selectedTab === 1 ? "bold" : "",
              }}
            />
          </Tabs>
        </div>
        <div className={scssClass.tableContainer}>
          {selectedTab === 0 && idToken && (
            <GridTable
              style={{ height: "calc(100vh - 31.5rem)" }}
              customPayload={true}
              isCustomizeColumns={false}
              title="Application List"
              apiConfig={{
                url: `${getEnv()?.baseURL}/appsetup/applicationDetails?env=${env}`,
                data: {
                  sortingFilter: {
                    filter: [],
                    sort: [],
                    page: {
                      limit: 25,
                      offset: 0,
                    },
                  },
                },
                headers: {
                  Authorization: idToken,
                  "x-api-key": "sasa",
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                documentUrl: "",
              }}
              refresh={refresh}
              onRowClick={(_, row: any) => {
                const rowStatus = row?.original?.status;
                if (
                  rowStatus === StatusType?.COMPLETED ||
                  rowStatus === StatusType?.DENIED ||
                  rowStatus === StatusType?.REVOKED
                ) {
                  navigate(`/application-list/app-${row?.original?.id}`);
                } else {
                  triggerToast(
                    `${row?.original?.app_cmdb_name} is in ${row?.original?.status} state, which cannot be edited.`,
                    "error",
                  );
                }
              }}
              cellActions={[
                {
                  event: "Approve",
                  callback: (event, data) => {
                    setPopupData(StatusType?.COMPLETED);
                    setReasonForAction("");
                    setActionRowData(data?.row?.original);
                    setActionPopup(true);
                  },
                  icon: false,
                },
                {
                  event: "Deny",
                  callback: (event, data) => {
                    setPopupData("Deny");
                    setReasonForAction("");
                    setActionRowData(data?.row?.original);
                    setActionPopup(true);
                  },
                  icon: false,
                },
                {
                  event: "Revoke",
                  callback: (event, data) => {
                    setPopupData("Revoke");
                    setReasonForAction("");
                    setActionRowData(data?.row?.original);
                    setActionPopup(true);
                  },
                  icon: false,
                },
              ]}
              isPagination={true}
              showLoader={false}
            />
          )}

          {selectedTab === 1 && idToken && (
            <GridTable
              style={{
                height: "calc(100vh - 34rem)",
                maxWidth: "calc(100vw - 4rem)",
              }}
              title="Application List"
              apiConfig={{
                url: "",
                data: {
                  sortingFilter: {
                    filter: [],
                    sort: [],
                    page: {
                      limit: 25,
                      offset: 0,
                    },
                  },
                },
                headers: {
                  Authorization: idToken,
                  "x-api-key": "sasa",
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                documentUrl: "",
              }}
              isPagination={true}
            />
          )}
        </div>
      </div>

      <Dialog
        open={actionPopup}
        // onClose={openActionPopup}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 400,
            fontSize: "24px",
            lineHeight: "32px",
          }}
        >
          {popupData === StatusType?.COMPLETED ? (
            <span>Approve Application</span>
          ) : popupData === "Deny" ? (
            <span>Deny Application</span>
          ) : popupData === "Revoke" ? (
            <span>Revoke Application</span>
          ) : (
            ""
          )}
          <IconButton onClick={openActionPopup}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            {popupData === StatusType?.COMPLETED ? (
              <span>
                Review and provide a short reason for approving the
                application request in the field below.
              </span>
            ) : popupData === "Deny" ? (
              <span>
                Review and provide a short reason for denying the application
                request in the field below.
              </span>
            ) : popupData === "Revoke" ? (
              <span>
                Please provide a short reason for revoking application in the
                field below.
              </span>
            ) : (
              ""
            )}

            {(popupData === StatusType?.COMPLETED ||
              popupData === StatusType?.DENY) && (
              <table className={scssClass.appActionPopupTable}>
                <tbody>
                  {/* changed td with th as th needed for table as existing code was not correctly added and failed with sonarqube error due to th missing */}
                  <tr>
                    <th style={{ width: "35%" }}>Name</th>
                    <th style={{ width: "65%" }}>
                      {actionRowData?.app_cmdb_name}
                    </th>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}>Description</td>
                    <td>{actionRowData?.description}</td>
                  </tr>
                  <tr>
                    <td>Primary Contact Name</td>
                    <td>{actionRowData?.primary_contact}</td>
                  </tr>
                  <tr>
                    <td>Business Owner Name</td>
                    <td>{actionRowData?.business_owner}</td>
                  </tr>
                  <tr>
                    <td>Value Stream</td>
                    <td>{actionRowData?.value_stream_name}</td>
                  </tr>
                  <tr>
                    <td>Application Code</td>
                    <td>{actionRowData?.app_cmdb_id}</td>
                  </tr>
                  <tr>
                    <td>Azure Application Name</td>
                    <td>{actionRowData?.azure_name}</td>
                  </tr>
                  <tr>
                    <td>Azure Application GUID</td>
                    <td>{actionRowData?.ad_app_guid}</td>
                  </tr>
                </tbody>
              </table>
            )}

            <table
              className={scssClass.appActionPopupTable}
              style={{ padding: 0, marginTop: 0 }}
            >
              <tbody>
                {/* added empty row with header as existing code was not correctly added and failed with sonarqube error due to th missing */}
                <tr>
                  <th></th>
                </tr>
                <tr>
                  <td colSpan={2}>
                    Comments <span style={{ color: "#C40818" }}>*</span>
                    <br />
                    <textarea
                      value={reasonForAction}
                      onChange={handleApproveReason}
                      style={{
                        width: "100%",
                        minHeight: "70px",
                        borderRadius: "5px",
                        margin: "5px 0",
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button variant="tertiary" onClick={openActionPopup}>
                Cancel
              </Button>
              <Button
                variant="primary"
                loading={loading}
                disabled={!reasonForAction}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCellAction(actionRowData);
                }}
              >
                {popupData === StatusType?.COMPLETED
                  ? StatusType?.APPROVE
                  : popupData === StatusType?.DENY
                    ? StatusType?.DENY
                    : popupData === StatusType?.REVOKE
                      ? StatusType?.REVOKE
                      : ""}
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ApplicationListMain;
